import {Point} from 'pixi.js';

export interface Loc {
    x: number;
    y: number;
}

export class Location implements Loc {
    public constructor(public x: number, public y: number) {
        // Sets instance properties
    }

    public offset(x: number, y: number): Location {
        return new Location(this.x + x, this.y + y);
    }

    public equals(other: Loc): boolean {
        return this.x === other.x && this.y === other.y;
    }

    public toString(): string {
        return `${this.x},${this.y}`;
    }

    public static fromString(string: string): Location {
        const [x, y] = string.split(',');
        return new Location(parseFloat(x), parseFloat(y));
    }

    public static fromPoint({x, y}: Point): Location {
        return new Location(x, y);
    }

    public asPoint(): Point {
        return new Point(this.x, this.y);
    }

    public floored(): Location {
        return new Location(Math.floor(this.x), Math.floor(this.y));
    }

    public static lerp(a: Loc, b: Loc, t: number): Location {
        return new Location(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    }

    public static fromLoc(loc: Loc): Location {
        return new Location(loc.x, loc.y);
    }

    public add(other: Location): Location {
        return new Location(this.x + other.x, this.y + other.y);
    }

    public sub(other: Location): Location {
        return new Location(this.x - other.x, this.y - other.y);
    }

    public normalized(): Location {
        const length = this.distanceTo({x: 0, y: 0});
        return new Location(this.x / length, this.y / length);
    }

    public multN(n: number): Location {
        return new Location(this.x * n, this.y * n);
    }

    public distanceTo(target: Loc): number {
        return Math.sqrt((target.x - this.x) ** 2 + (target.y - this.y) ** 2);
    }
}



// WEBPACK FOOTER //
// ./src/common/map/Location.ts